<template>
  <div :class="['xfield-modal-root', isPageLayout ? 'xfield-layout-page' : '']">
    <div
      :class="
        isPageLayout
          ? 'xfield-page-shell'
          : 'product-details-obscurator fade-obscurator'
      "
    >
      <div
        :class="
          isPageLayout
            ? 'xfield-page-form'
            : 'product-details-sidebar xfield-edit-sidebar'
        "
      >
        <div v-if="!isPageLayout" class="edit-header d-flex">
          <div class="w-100 text-default">
            <!-- {{ product.vendor_name ? product.vendor_name : product.product_place_name }} -->
            <strong> Editar {{ object.type?object.type.value:'Item' }}</strong>
            <br />
            <span class="w-100">
              {{ object.vendor_name ? (object.product_place_name ? object.product_place_name.value : '') : '' }}
              -
              {{ object.product_name ? object.product_name.value : '' }}
            </span>
          </div>
        </div>

        <button
          v-if="!isPageLayout"
          style="position: absolute; top: 30px; right: 40px"
          @click.prevent="closeModal()"
          type="button"
          aria-label="Close"
          class="close"
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.5 1.5L16.5 16.5"
              stroke="#8D8D8D"
              stroke-width="3"
              stroke-linecap="round"
            />
            <path
              d="M16.5 1.5L1.5 16.5"
              stroke="#8D8D8D"
              stroke-width="3"
              stroke-linecap="round"
            />
          </svg>
        </button>

        <div :class="`xfield-panel-body pb-4`" id="xfield-panel-body">
          <b-form>
            <!-- START xfields data form xfields definitions -->
            <div
              v-show="Object.keys(xFields).length"
              class="xFieldsDataWrapper"
            >
              <!-- START xfields data form xfields definitions fields=[session_title, [field1, field2, field3]]-->
              <div
                v-for="(fields, session_title) in enabledFormFields"
                :key="`${session_title}`"
              >
                <div
                  v-show="currentPage.includes(fields[0])"
                  :class="[`${fields[0]}`]"
                >
                  <div class="row">
                    <div
                      v-for="field in fields[1]"
                      :key="field.id"
                      v-show="
                        (field.type != 'hidden_config' &&
                          (field.add_display == 2 ||
                            field.add_display == 1 ||
                            field.add_display == 3)) ||
                        field.label.indexOf('page_') === 0 ||
                        field.label.indexOf('session_') === 0
                      "
                      :class="
                        field.type == 'hidden_config' ||
                        field.label.indexOf('_title') >= 0 ||
                        ['radio', 'checkboxmultiple', 'textarea'].includes(
                          field.type
                        )
                          ? field.label.indexOf('page_') === 0
                            ? `col-12 mb-7`
                            : `col-12 mb-4`
                          : 'col-md-12 mb-2'
                      "
                      :style="
                        field.type == 'radio' && field.inline_float == 'true'
                          ? 'margin-top: 0px !important;'
                          : ''
                      "
                    >
                      <!-- <div v-if="
                        field.options[0] &&
                        fields[1].filter(
                          (field) => field.label == currentPage[0]
                        )[0] &&
                        field.options[0].page_title
                      " :class="`w-100 ${field.options[0] && field.options[0].page_subtitle
                            ? 'mt-5'
                            : 'mt-2'
                          }`">
                        &nbsp;
                      </div> -->
                      <i v-if="field.add_display == 2" class="text-red">
                        {{ field.label }} : {{ field.type }} (add_display:{{
                          field.add_display
                        }})
                      </i>
                      <!-- <i>
                          DEBUG AREA <br />
                          {{ field.label }} : {{ field.type }} :
                          {{
                            xFieldsData[field.label] &&
                            xFieldsData[field.label]['value']
                              ? xFieldsData[field.label]['value']
                              : '--'
                          }}
                          <br />
                          options: {{ field }}
                        </i> -->

                      <!-- Page Title -->
                      <h2
                        class="page_title w-100"
                        v-if="field.options[0] && field.options[0].page_title"
                      >
                        <span
                          class="bg-white align-items-center"
                          style="color: #12576e; font-weight: 600"
                        >
                          <i
                            v-if="
                              field.options[0] && field.options[0].icon_class
                            "
                            :class="`${field.options[0].icon_class} pr-1`"
                          ></i>

                          {{
                            field.options[0].page_title
                              ? field.options[0].page_title
                              : ''
                          }}
                          <small
                            v-if="
                              field.options[0] &&
                              field.options[0].page_subtitle != ''
                            "
                            class="text-muted d-block"
                          >
                            {{
                              field.options[0].page_subtitle
                                ? field.options[0].page_subtitle
                                : ''
                            }}
                          </small>
                        </span>
                      </h2>

                      <!-- Session Title -->
                      <h3
                        v-if="
                          field.type == 'hidden_config' &&
                          field.label.indexOf('session_title') === 0 &&
                          (field.add_display == 1 || field.add_display == 3)
                        "
                        class="xfield-session-title pt-6 w-100 text-center"
                      >
                        <span
                          class="xfield-session-title-label pr-4 pl-4 bg-white"
                        >
                          <i
                            v-if="field.class"
                            :class="field.class"
                            class="xfield-session-title-icon"
                          ></i>
                          <span
                            v-if="field.icon"
                            class="xfield-session-title-img-wrap"
                          >
                            <img
                              :src="field.icon"
                              class="xfield-session-title-img"
                              :alt="field.public_label || field.label"
                            />
                          </span>
                          <span class="xfield-session-title-text">
                            {{
                              field.public_label
                                ? field.public_label
                                : field.label
                            }}
                          </span>
                        </span>
                        <hr class="mt--2" />
                        <small
                          v-if="field.public_sub_label"
                          class="text-muted d-block mb-4 mt--4"
                        >
                          {{ field.public_sub_label }}
                        </small>
                      </h3>
                      <!-- Base input for many types -->
                      <base-input
                        v-if="
                          field.type != 'hidden_config' && field.type != 'img'
                        "
                        :name="field.label"
                        :class="{
                          'xfield-radio-icon-row': isRadioIconMulti(field),
                          'mb-4': isRadioIconMulti(field),
                        }"
                      >
                        <template
                          v-if="
                            field.type != 'checkbox' && fieldLabelText(field)
                          "
                          slot="label"
                        >
                          <div class="form-control-label">
                            <label
                              :style="{
                                float:
                                  field.type == 'radio' &&
                                  field.inline_float == 'true' &&
                                  !isPageLayout
                                    ? 'left'
                                    : 'unset',
                              }"
                              v-html="fieldLabelText(field)"
                            ></label>
                            <small
                              v-if="field.public_sub_label != ''"
                              class="text-muted d-block mb-4 mt--2"
                            >
                              {{ field.public_sub_label }}
                            </small>
                          </div>
                        </template>
                        <!-- file-image: preview + remover ou seletor -->
                        <div
                          v-if="field.type == 'file-image' || field.type == 'image'"
                          class="xfield-file-image"
                        >
                          <div
                            v-if="getFileImagePreview(field)"
                            class="xfield-file-image-preview"
                          >
                            <img
                              :src="getFileImagePreview(field)"
                              :alt="field.public_label || field.label"
                              class="xfield-file-image-thumb"
                            />
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-danger xfield-file-image-remove"
                              :disabled="blockEdit"
                              @click.prevent="removeFileImage(field)"
                            >
                              <i class="fas fa-trash-alt mr-1"></i>
                              Remover
                            </button>
                          </div>
                          <b-form-file
                            v-else
                            @change="onFileChange"
                            :name="field.label"
                            :public_label="field.public_label"
                            :disabled="blockEdit"
                            accept=".jpg, .png, .jpeg, .webp, .svg, .gif"
                            size="md"
                            placeholder="Escolha uma imagem..."
                            drop-placeholder="Solte a imagem aqui..."
                          />
                        </div>

                        <!-- files -->
                        <b-form-file
                          v-else-if="field.type == 'file'"
                          @change="onFileChange"
                          :name="field.label"
                          :public_label="field.public_label"
                          :disabled="blockEdit"
                          accept=".pdf, .doc, .docx, .xls, .csv, .xlsx"
                          size="md"
                          placeholder="Escolha um arquivo..."
                        >
                        </b-form-file>

                        <!-- checkbox -->
                        <div
                          v-if="field.type == 'checkbox' && !field.multiple"
                          class="checkbox_session"
                        >
                          <label
                            class="checkbox-list-card single-checkbox-card"
                            :class="{
                              selected: !!xFieldsData[field.label]['value'],
                            }"
                          >
                            <div class="custom-checkbox-indicator">
                              <input
                                type="checkbox"
                                v-model="xFieldsData[field.label]['value']"
                                :disabled="blockEdit"
                                class="custom-checkbox-input"
                              />
                              <span class="custom-checkbox-box">
                                <svg
                                  v-if="!!xFieldsData[field.label]['value']"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="3"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="check-svg"
                                >
                                  <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                              </span>
                            </div>
                            <div class="checkbox-list-content">
                              <span class="checkbox-list-title">{{
                                field.public_label
                              }}</span>
                              <span
                                v-if="field.public_sub_label != ''"
                                class="checkbox-list-details"
                              >
                                {{ field.public_sub_label }}
                              </span>
                            </div>
                          </label>
                        </div>

                        <!-- MultiSelect -->
                        <div
                          v-if="
                            field.type == 'selectxxxx' && field.multiple == true
                          "
                          class="multiselect_session"
                        >
                          <multiselect
                            v-model="xFieldsData[field.label]['value']"
                            :multiple="field.multiple"
                            :id="field.label"
                            :disabled="blockEdit"
                            :close-on-select="!field.multiple"
                            :clear-on-select="false"
                            :hide-selected="false"
                            :placeholder="
                              field.multiple ? 'Selecionar...' : 'Escolher...'
                            "
                            deselect-label="Remover"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            track-by="id"
                            label="label"
                            :options="field.options"
                            :searchable="
                              field.options && field.options.length > 6
                            "
                          >
                          </multiselect>
                        </div>

                        <!-- Select Multiple -->
                        <div
                          v-if="field.type == 'select' && field.multiple"
                          class="select_multiple_session"
                        >
                          <b-form-select
                            :disabled="blockEdit"
                            v-model="xFieldsData[field.label]['value']"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option value="" disabled>{{
                                field.multiple ? 'Selecionar...' : 'Escolher...'
                              }}</b-form-select-option>
                            </template>
                            <b-form-select-option
                              v-for="item in field.options"
                              :value="item.value"
                              :key="item.id"
                            >
                              {{ item.label }}
                            </b-form-select-option>
                          </b-form-select>
                        </div>

                        <!-- Select Single -->
                        <div
                          v-if="field.type == 'select' && !field.multiple"
                          class="select_sigle_session"
                        >
                          <b-form-select
                            :id="field.label"
                            :value="field"
                            v-model="xFieldsData[field.label]['value']"
                            class="mb-3"
                            :disabled="blockEdit"
                            :options="field.options"
                          >
                          </b-form-select>
                        </div>

                        <!-- date  -->
                        <div
                          v-if="field.type == 'date'"
                          class="datepicker_session"
                        >
                          <date-picker
                            v-model="xFieldsData[field.label]['value']"
                            :disabled="blockEdit"
                            type="date"
                            format="dd/MM/yyyy"
                            value-format="yyyy-MM-dd"
                            class="w-100 mb-1"
                          >
                          </date-picker>
                        </div>

                        <!-- Textarea -->
                        <b-textarea
                          v-if="
                            field.type == 'textarea' && !isImagePickerField(field)
                          "
                          :id="field.label"
                          v-model="xFieldsData[field.label]['value']"
                          :disabled="blockEdit"
                          class="textarea_session"
                        ></b-textarea>

                        <div
                          v-if="isImagePickerField(field)"
                          class="xfield-image-picker-trigger"
                        >
                          <b-button
                            type="button"
                            variant="outline-primary"
                            size="sm"
                            :disabled="blockEdit"
                            @click.prevent="openImagePicker(field.label)"
                          >
                            <i class="fas fa-images mr-1" aria-hidden="true"></i>
                            Editar Imagens
                            <span
                              v-if="imagePickerCount(field.label)"
                              class="ml-1"
                            >
                              ({{ imagePickerCount(field.label) }})
                            </span>
                          </b-button>
                          <xfield-file-image-picker
                            :visible.sync="imagePickerVisible[field.label]"
                            v-model="xFieldsData[field.label]['value']"
                            :media-type="
                              (field.options && field.options.media_type) ||
                              'image/jpeg;image/png'
                            "
                            :title="field.public_label || 'Galeria de imagens'"
                            :disabled="blockEdit"
                            @setImagePickerValue="setImagePickerValue(field.label, $event)"
                          />
                        </div>

                        <!-- Radio Buttons -->
                        <div
                          v-if="field.type == 'radio'"
                          :class="[
                            field.options[0] && field.options[0].class
                              ? 'radio_session_icon'
                              : 'radio_session',
                            field.type == 'radio' ? 'mt--2' : '',
                            isPageLayout &&
                            field.options[0] &&
                            field.options[0].class
                              ? 'mb-4'
                              : '',
                          ]"
                          :style="{
                            float:
                              field.type == 'radio' &&
                              field.inline_float == 'true' &&
                              !isPageLayout
                                ? 'right'
                                : '',
                          }"
                        >
                          <label
                            v-for="val in getSafeFieldOptions(field)"
                            :key="val.id"
                            :class="{
                              selected:
                                String(val.id) ===
                                String(
                                  xFieldsData[field.label] &&
                                    xFieldsData[field.label].value
                                ),
                              'radio-card-box': !val.class,
                              'radio-class-box': val.class,
                              'mr-4':
                                field.type == 'radio' &&
                                isRadioIconMulti(field),
                              'ml-4':
                                field.type == 'radio' &&
                                isRadioIconMulti(field),
                            }"
                          >
                            <input
                              type="radio"
                              :name="field.label"
                              :value="val.id"
                              :disabled="blockEdit"
                              v-model="xFieldsData[field.label].value"
                              class="hidden-custom-input"
                              @change="
                                setRadioIcon(
                                  field.label,
                                  $event.target.value
                                )
                              "
                            />

                            <div class="radio-card-header">
                              <div v-if="val.class">
                                <i
                                  :class="[
                                    val.class,
                                    isPageLayout
                                      ? 'xfield-page-radio-icon'
                                      : 'font-size-xxl',
                                  ]"
                                  :title="val.details"
                                ></i>
                              </div>
                              <div v-else>
                                <strong class="radio-card-title">{{
                                  val.label
                                }}</strong>
                                <div
                                  class="radio-card-details"
                                  v-if="val.details"
                                >
                                  {{ val.details }}
                                </div>
                              </div>
                              <!-- <span class="badge-ver-exemplo" v-if="val.details"
                                >ver exemplo</span
                              > -->
                            </div>
                          </label>
                        </div>

                        <!-- Checkbox Multiple (Com ícones: Grid de Cards) -->
                        <div
                          v-if="
                            field.type == 'checkboxmultiple' &&
                            hasIconOptions(field)
                          "
                          class="checkboxmultiple_grid"
                        >
                          <label
                            v-for="val in getSafeFieldOptions(field)"
                            :key="val.id"
                            class="icon-checkbox-box"
                            :class="{
                              selected: isOptionChecked(field.label, val),
                            }"
                          >
                            <input
                              type="checkbox"
                              :multiple="field.multiple"
                              :checked="isOptionChecked(field.label, val)"
                              :disabled="blockEdit"
                              @change="
                                selectMultipleValue(
                                  'change',
                                  field.label,
                                  field.multiple,
                                  val.id,
                                  $event.target.checked
                                )
                              "
                              class="hidden-custom-input"
                            />
                            <div class="icon-checkbox-img-wrap">
                              <img
                                v-if="val.icon"
                                :src="`${val.icon}`"
                                class="icon-checkbox-img"
                                :alt="val.label"
                              />
                              <span
                                v-else-if="
                                  getCategorySvg(val.label || val.value)
                                "
                                v-html="getCategorySvg(val.label || val.value)"
                                class="icon-checkbox-svg-wrap"
                              ></span>
                              <div v-else class="icon-checkbox-placeholder">
                                <i class="ni ni-compass-04"></i>
                              </div>
                            </div>
                            <span class="icon-checkbox-label">
                              {{ val.label }}
                            </span>
                            <span
                              v-if="val.details"
                              class="icon-checkbox-details"
                            >
                              {{ val.details }}
                            </span>
                          </label>
                        </div>

                        <!-- Checkbox Multiple (Sem ícones: Lista em 3 Colunas com fundo claro) -->
                        <div
                          v-if="
                            field.type == 'checkboxmultiple' &&
                            !hasIconOptions(field)
                          "
                          class="checkbox_list_3col"
                        >
                          <label
                            v-for="val in getSafeFieldOptions(field)"
                            :key="val.id"
                            class="checkbox-list-card"
                            :class="{
                              selected: isOptionChecked(field.label, val),
                            }"
                          >
                            <div class="custom-checkbox-indicator">
                              <input
                                type="checkbox"
                                :multiple="field.multiple"
                                :checked="isOptionChecked(field.label, val)"
                                :disabled="blockEdit"
                                @change="
                                  selectMultipleValue(
                                    'change',
                                    field.label,
                                    field.multiple,
                                    val.id,
                                    $event.target.checked
                                  )
                                "
                                class="custom-checkbox-input"
                              />
                              <span class="custom-checkbox-box">
                                <svg
                                  v-if="isOptionChecked(field.label, val)"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="3"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="check-svg"
                                >
                                  <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                              </span>
                            </div>
                            <div class="checkbox-list-content">
                              <span class="checkbox-list-title">{{
                                val.label
                              }}</span>
                              <span
                                v-if="val.details"
                                class="checkbox-list-details"
                                >{{ val.details }}</span
                              >
                            </div>
                          </label>
                        </div>

                        <div v-if="field.type == 'color'" class="xfield-color">
                          <label
                            class="xfield-color-swatch"
                            :class="{
                              'xfield-color-swatch--set': colorIsSet(field),
                            }"
                            :style="colorSwatchStyle(field)"
                          >
                            <input
                              type="color"
                              class="xfield-color-input"
                              :value="colorInputValue(field)"
                              :disabled="blockEdit"
                              @input="setColorValue(field, $event.target.value)"
                            />
                          </label>
                          <span class="xfield-color-hex">{{
                            colorInputLabel(field)
                          }}</span>
                          <button
                            v-if="colorIsSet(field) && !blockEdit"
                            type="button"
                            class="xfield-color-clear"
                            @click.prevent="clearColorValue(field)"
                          >
                            Limpar
                          </button>
                        </div>

                        <!-- phone number flag -->
                        <b-row align-h="between" class="phone_session">
                          <b-col
                            v-if="['mobile', 'phone'].includes(field.label)"
                            cols="3"
                          >
                            <b-form-select v-model="phoneFlag" class="mb-3">
                              <template #first>
                                <b-form-select-option value="" disabled
                                  >Selecione o país</b-form-select-option
                                >
                              </template>

                              <b-form-select-option
                                :class="flag"
                                v-for="(flag, idx) in dialCodesArray"
                                :value="flag.iso"
                                :key="idx"
                              >
                                {{
                                  getFlagEmoji(flag.iso) +
                                  ' ' +
                                  flag.name +
                                  ' +' +
                                  flag.dialcode
                                }}
                              </b-form-select-option>
                            </b-form-select>
                          </b-col>

                          <!-- all other fields -->
                          <b-col
                            :cols="
                              ['mobile', 'phone'].includes(field.label)
                                ? '9'
                                : '12'
                            "
                            class="general_fields_session"
                          >
                            <!-- Start Other Inputs -->
                            <b-input
                              v-if="
                                xFieldsData[field.label] &&
                                xFieldsData[field.label].mask === 'document'
                              "
                              v-model="xFieldsData[field.label]['value']"
                              type="text"
                              maxlength="18"
                              placeholder="CPF, CNPJ ou Passaporte"
                              :disabled="blockEdit"
                              v-mask="
                                getDocMask(xFieldsData[field.label]['value'])
                              "
                              @keyup="upperCaseXFieldDoc(field.label)"
                            >
                            </b-input>
                            <b-input
                              v-else-if="
                                ![
                                  'checkbox',
                                  'checkboxmultiple',
                                  'file',
                                  'radio',
                                  'select',
                                  'file-image',
                                  'selectmultiple',
                                  'date',
                                  'textarea',
                                  'color',
                                ].includes(field.type)
                              "
                              v-model="xFieldsData[field.label]['value']"
                              :value="xFieldsData[field.label]['value']"
                              :type="field.type"
                              :disabled="blockEdit"
                            >
                            </b-input>
                          </b-col>
                        </b-row>
                      </base-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END xfield sessions -->
          </b-form>
        </div>

        <div class="product-details-footer">
          <div class="w-100">
            <div class="footer-progress-bar mb-3">
              <div
                class="footer-progress-bar-inside"
                :style="{ width: progressPercentage }"
              >
                {{ progressPercentage }}
              </div>
            </div>

            <div class="modal-add-footer">
              <div class="d-flex w-100 align-items-center" style="gap: 12px">
                <div
                  class="w-100"
                  v-if="
                    Object.keys(this.pages).filter(
                      (page) => page.indexOf('pagecontrol_') === 0
                    ).length > 1
                  "
                >
                  <button
                    type="button"
                    @click.prevent="previousPage()"
                    :disabled="!isBackable || disablePreviousButton"
                    :class="`btn btn-outline-nav w-100 ${
                      !isBackable || disablePreviousButton ? 'disabled' : ''
                    }`"
                  >
                    Voltar
                  </button>
                </div>
                <div
                  class="w-100"
                  v-if="
                    Object.keys(this.pages).filter(
                      (page) => page.indexOf('pagecontrol_') === 0
                    ).length > 1
                  "
                >
                  <button
                    type="button"
                    @click.prevent="nextPage()"
                    :disabled="!isNextable"
                    :class="`btn btn-primary-nav w-100 ${
                      !isNextable ? 'disabled' : ''
                    }`"
                  >
                    Avançar
                  </button>
                </div>
                <div v-if="!blockEdit" class="w-100 d-flex" style="gap: 12px">
                  <b-button
                    v-if="showCancel"
                    size="sm"
                    variant="secondary"
                    :disabled="formWaiting"
                    @click.prevent="$emit('cancel')"
                    class="btn"
                  >
                    Cancelar
                  </b-button>
                  <b-button
                    size="sm"
                    variant="success"
                    :disabled="formWaiting"
                    @click.prevent="saveXFieldsData()"
                    class="btn w-100 btn-save-exit"
                  >
                    {{ isPageLayout ? 'Enviar' : 'Salvar' }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DatePicker } from 'element-ui'
import { isMobile, strNormalize } from '../../store/utils/general'
import Multiselect from 'vue-multiselect'
import { hasModule } from '../../store/utils/users'
import { VueMaskDirective } from 'v-mask'
import { fetchFileObjectUrl } from '@/store/utils/publicLogoFile'
import XFieldFileImagePicker from './XFieldFileImagePicker.vue'

export default {
  name: 'EditXFieldModal',
  components: {
    DatePicker,
    Multiselect,
    'xfield-file-image-picker': XFieldFileImagePicker,
  },
  directives: { mask: VueMaskDirective },
  props: {
    coreObject: {
      type: String,
      default: '',
    },

    xFields: {
      type: Object,
      default: {},
    },
    currentXFieldDetail: {
      type: [Object, String],
      default: () => ({}),
    },
    xFieldsData: {
      type: Object,
      default: {},
    },
    object: {
      type: Object,
      default: {},
    },
    layoutMode: {
      type: String,
      default: 'sidebar',
      validator(value) {
        return ['sidebar', 'page'].includes(value)
      },
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      xfieldDetails: {},
      confirmButtonLabel: 'SALVAR',
      formWaiting: false,
      blockEdit: false,
      formErrors: false,
      isDocsModalOpen: false,
      pages: {
        pagecontrol_1: ['base_buttons_session', 'user_data_session', 'page_1'],
        zLast: [],
      },
      phoneFlag: 'BR',
      pageControl: 'pagecontrol_1',
      tmpFiles: {},
      agentUploadImage: null,
      agentTmpImage: null,
      handle_city_agents: false,
      handle_my_place_agents: false,
      fieldErrors: {},
      multipleSelectValues: {},
      disablePreviousButton: true,
      pageOpenedAt: null,
      fileImageLocalPreviews: {},
      fileImageRemotePreviews: {},
      fileImageLoading: {},
      imagePickerVisible: {},
    }
  },
  created() {
    // Fora do `data()`: Vue 2 não observa; File permanece intacto para upload
    this._imagePickerFiles = Object.create(null)
  },
  beforeDestroy() {
    this.revokeAllFileImagePreviews()
    this._imagePickerFiles = Object.create(null)
  },
  computed: {
    getImagePickerFiles() {
      return this._imagePickerFiles
    },
    ...mapGetters('booking', {
      dialCodesArray: 'getDialCodesArray',
    }),

    ...mapGetters('auth', {
      loggedUser: 'user',
      place: 'getPlace',
    }),

    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    isActive() {
      return true
    },

    isPageLayout() {
      return this.layoutMode === 'page'
    },

    formedFields() {},
    enabledFormFields() {
      let formattedXFieldData = {}
      const enabledFieldsFlag = false
      let enabledFields = [
        'page_1',
        'product_name',
        'type',
        'category',
        'subcategory',
        'activity_categories',
        'what_to_do',
        'description',
        'cover',
        'images',
        'videos',
        'location_logo',
        'page_2',
        'product_place_name',
        'product_place',
        'location_country',
        'location_state',
        'location_city',
        'location_region',
        'geolocation',
        'short_description',
        'how_to_get_there',
        'public_transport_options',
        'page_3',
        'allowed_age',
        'activity_duration',
        'activity_difficulty',
        'required_skills',
        'accessibility',
        'tags',
        'what_to_bring',
        'page_4',
        'guidance',
        'guidance_list',
        'includes',
        'not_included',
        'activity_rules_info',
        'activity_recomendations',
        'activity_rules',
        'security_warning',
        'commitment_terms',
        'commitment_terms_text',
        'faq',
        'page_5',
        'activity_price',
        'ticket_price_info',
        'special_prices',
        'tickets',
        'max_discount',
        // 'commission',
        'local_sale',
        'capacity',
        'availability',
        'unavailability',
        'starting_limit',
        'closing_time',
        'page_6',
        'active',
        'visibility',
        'vendor_alert_number',
        'notification_number',
        'nps_group',
        'nps_link',
        'configuration',
        'uuid',
        'slug',
        'id',
      ]

      let defaultXFieldsDataFields = {
        add_display: 0,
        buy_editable: 0,
        display: 0,
        id: 0,
        label: '',
        value: '',
        laraveldata: false,
        options: [],
        public_label: '',
        type: 'text',
      }

      // match data fields with xfields definitions and creates a new xFields entry if necessary
      Object.keys(this.xFieldsData).forEach((key, index) => {
        let _xfield_data = JSON.parse(JSON.stringify(this.xFieldsData[key]))

        if (
          _xfield_data.type != undefined &&
          this.xFields[key] != undefined &&
          _xfield_data.type != this.xFields[key].type
        ) {
          _xfield_data.type = `${this.xFields[key].type}`
          this.xFieldsData[key].type = `${this.xFields[key].type}`
        }

        if (this.xFields[key] == undefined) {
          let fieldType = typeof _xfield_data.value
          let newField = JSON.parse(JSON.stringify(defaultXFieldsDataFields))
          newField.label = key
          newField.add_display = _xfield_data.add_display || 1
          newField.buy_editable = _xfield_data.buy_editable || 0
          newField.display = _xfield_data.display || true
          newField.id = _xfield_data.id || index + 1000
          newField.options = _xfield_data.options || []
          newField.public_label = _xfield_data.public_label || ''
          switch (fieldType) {
            case 'boolean':
              newField.type = 'checkbox'
              break
            case 'number':
              newField.type = 'number'
              break
            case 'object':
              newField.type = 'textarea'
              //   break;
              // case 'array':
              //   newField.type = 'selectmultiple'
              break

            default:
              newField.type = _xfield_data.type || 'text'
              break
          }
          if (_xfield_data.value != undefined) {
            newField.value = _xfield_data.value
          } else if (_xfield_data.label != undefined) {
            newField.value = _xfield_data.label
          } else {
            newField.value = _xfield_data
          }
          newField.new = true

          if (enabledFields.indexOf(key) >= 0 && enabledFieldsFlag) {
            this.xFields[key] = JSON.parse(JSON.stringify(newField))
          }
        }
      })

      // match xfields definitions with data fields and creates a new XFieldsData entry if necessary
      Object.values(this.xFields).map((_xfield) => {
        /**
         * question title syntax: public_label#public_sub_label
         * split title into public_label and public_sub_label
         * example: "public_label": "Se você contratou um guia ou condutor para esse passeio#public_sub_label='Avalie essa experiência'",
         */
        let title = this.xFields[_xfield.label]['public_label'].split('#')
        this.xFields[_xfield.label]['public_label'] = title[0]
        if(!this.xFields[_xfield.label]['public_sub_label'] && title.length > 1) {
          this.xFields[_xfield.label]['public_sub_label'] = title[1] || ''
        }

        if (
          !this.xFields[_xfield.label]['public_sub_label'] &&
          title.length > 1
        ) {
          let parsedOption = title[1].replace(/'[^']*'/g, (match) =>
            match.replace(/;/g, ',')
          )
          parsedOption = parsedOption.replace(/\(([^()]*)\)/g, (match) =>
            match.replace(/;/g, ',')
          )
          parsedOption = parsedOption.split(';')
          parsedOption.forEach((item) => {
            item = item.split('=')
            if (item[1]) {
              this.xFields[_xfield.label][item[0]] = item[1]
                .replaceAll('_ ', ': ')
                .replaceAll("'", '')
            }
          })
        }
        //check the metadata has all required fields
        if (
          _xfield.label &&
          _xfield.type != 'disabled' &&
          _xfield.type != 'hidden_config'
        ) {
          //if no data found
          if (this.xFieldsData[_xfield.label] == undefined) {
            if (this.xFieldsData[_xfield.public_label] == undefined) {
              // Vue 2: new keys on prop objects need $set or v-model/radio UI won't react
              this.$set(
                this.xFieldsData,
                _xfield.label,
                JSON.parse(JSON.stringify(this.xFields[_xfield.label]))
              )
            } else {
              //change old label and set public_label
              this.$set(this.xFieldsData, _xfield.label, {
                ...JSON.parse(JSON.stringify(this.xFields[_xfield.label])),
                ...JSON.parse(
                  JSON.stringify(this.xFieldsData[_xfield.public_label])
                ),
              })
              this.$delete(this.xFieldsData, _xfield.public_label)
            }
          } else {
            //OLD fix. data saved on label property
            if (
              this.xFieldsData[_xfield.label].value == undefined &&
              this.xFieldsData[_xfield.label].label != undefined
            ) {
              this.xFieldsData[_xfield.label].value =
                this.xFieldsData[_xfield.label].label
              this.xFieldsData[_xfield.label].label = _xfield.label
            }

            //force to set value as string if it's not an array or object (for compatibility with old data saved without type definition)
            if (
              Object.prototype.toString.call(
                this.xFieldsData[_xfield.label].value
              ) != '[object Array]' &&
              Object.prototype.toString.call(
                this.xFieldsData[_xfield.label].value
              ) != '[object Object]'
            ) {
              this.xFieldsData[_xfield.label].value =
                this.xFieldsData[_xfield.label].value != undefined
                  ? `${this.xFieldsData[_xfield.label].value}`
                  : ''
            } else {
              if (_xfield.type != 'selectmultiple') {
                this.xFieldsData[_xfield.label].value = JSON.stringify(
                  this.xFieldsData[_xfield.label].value
                )
              }
            }
          }

          if (
            _xfield.type.indexOf('selectmultiple') >= 0 &&
            typeof _xfield.options == 'object'
          ) {
            let _options = []

            // this.xFieldsData[_xfield.label].type = 'select'

            Object.keys(_xfield.options).forEach((key) => {
              let option = _xfield.options[key]
              if (option.indexOf('=') >= 0) {
                option = option.split('=')
              } else {
                option = option.split(':')
              }
              _options.push({
                id: option[0],
                value: option[0],
                label: option[1] || option[0],
              })
              // if(_xfield.multiple === true){
              // }else{
              //   _options.push(_xfield.options[key]+'zzz')
              // }
            })

            this.xFields[_xfield.label].options = JSON.parse(
              JSON.stringify(_options)
            )
            // if (this.xFields[_xfield.label].type.indexOf('multiple') >= 0) {
            //   this.xFields[_xfield.label].multiple = true
            // }

            //formats current value as object option
            if (this.xFields[_xfield.label].type != 'selectmultiple') {
              if (
                this.xFieldsData[_xfield.label].value != '' &&
                this.xFieldsData[_xfield.label].value != undefined &&
                this.xFields[_xfield.label].options.filter(
                  (item) => item.value == this.xFieldsData[_xfield.label].value
                ).length == 0
              ) {
                //inserts current value as option in xfields (definitions)
                // this.xFields[_xfield.label].options.push({
                //   id: this.xFieldsData[_xfield.label].value,
                //   value: this.xFieldsData[_xfield.label].value,
                //   label: this.xFieldsData[_xfield.label].value,
                // })
                // if(_xfield.multiple === true){
                // }else{
                // }
              }
              // this.xFields[_xfield.label].options.push(this.xFieldsData[_xfield.label].value.replaceAll('; ',' ')+'sdf')

              // this.xFieldsData[_xfield.label].value = {
              //   id: this.xFieldsData[_xfield.label].value,
              //   value: this.xFieldsData[_xfield.label].value,
              //   label: this.xFieldsData[_xfield.label].value,
              // }
              // if(_xfield.multiple === true){
              // }else{
              //   this.xFieldsData[_xfield.label].value = this.xFieldsData[_xfield.label].value
              // }
            } else {
              //select multiple
              let _options = []
              if (
                typeof this.xFieldsData[_xfield.label].value == 'object' &&
                this.xFieldsData[_xfield.label].value.length > 0
              ) {
                this.xFieldsData[_xfield.label].value.forEach((item) => {
                  _options.push({
                    id: item,
                    value: item,
                    label: item,
                  })
                })
                this.xFieldsData[_xfield.label].value = _options
              } else {
                this.xFieldsData[_xfield.label].value = {
                  id: this.xFieldsData[_xfield.label].value,
                  value: this.xFieldsData[_xfield.label].value,
                  label: this.xFieldsData[_xfield.label].value,
                }
              }

              formattedXFieldData[_xfield.label] = this.handleDynamicOptions(
                {
                  ...this.xFields[_xfield.label],
                  ...JSON.parse(
                    JSON.stringify(this.xFieldsData[_xfield.label])
                  ),
                },
                {
                  currentUserPois: this.poisList,
                }
              )
            }

            // formattedXFieldData[_xfield.label] = {
            //   ...JSON.parse(JSON.stringify(this.xFieldsData[_xfield.label])),
            // }
          } else {
            formattedXFieldData[_xfield.label] = {
              ...JSON.parse(JSON.stringify(defaultXFieldsDataFields)),
              ...JSON.parse(JSON.stringify(this.xFieldsData[_xfield.label])),
              ...JSON.parse(JSON.stringify(this.xFields[_xfield.label])),
            }
            if (
              this.xFieldsData[_xfield.label] &&
              this.xFieldsData[_xfield.label].value !== undefined
            ) {
              formattedXFieldData[_xfield.label].value =
                this.xFieldsData[_xfield.label].value
            }
            delete this.xFieldsData[_xfield.label].options
          }

          if (_xfield.type === 'color' && this.xFieldsData[_xfield.label]) {
            this.$set(
              this.xFieldsData[_xfield.label],
              'value',
              this.normalizeHexColor(this.xFieldsData[_xfield.label].value)
            )
          }

          formattedXFieldData[_xfield.label] = this.convertMetaType(
            formattedXFieldData[_xfield.label]
          )
          this.xFields[_xfield.label].options = JSON.parse(
            JSON.stringify(formattedXFieldData[_xfield.label].options)
          )

          this.xFields[_xfield.label].multiple =
            formattedXFieldData[_xfield.label].multiple || false

          if (
            this.xFields[_xfield.label].type !=
              formattedXFieldData[_xfield.label].type &&
            formattedXFieldData[_xfield.label].type != undefined
          ) {
            this.xFields[_xfield.label].type =
              formattedXFieldData[_xfield.label].type
          }

          if (formattedXFieldData[_xfield.label].mask) {
            this.$set(
              this.xFields[_xfield.label],
              'mask',
              formattedXFieldData[_xfield.label].mask
            )
          }

          // if (
          //   undefined != formattedXFieldData[_xfield.label]['cumulative'] &&
          //   formattedXFieldData[_xfield.label]['cumulative'] == true
          // ) {
          //   let values = []
          //   let valueIds = []
          //   if (
          //     undefined != formattedXFieldData[_xfield.label]['value'] &&
          //     Object.prototype.toString.call(
          //       formattedXFieldData[_xfield.label]['value']
          //     ) == '[object Array]'
          //   ) {
          //     formattedXFieldData[_xfield.label]['value'].forEach((vItem) => {
          //       if (valueIds.indexOf(vItem.id) == -1) {
          //         valueIds.push(vItem.id)
          //         values.push(vItem)
          //       }
          //     })
          //   }
          //   formattedXFieldData[_xfield.label]['value'] = values
          // }

          // image-picker pode ter File[]; JSON.stringify apaga o conteúdo do File
          const previousImagePickerValue = this.isImagePickerField(
            this.xFields[_xfield.label]
          )
            ? this.xFieldsData[_xfield.label] &&
              this.xFieldsData[_xfield.label].value
            : null

          this.$set(
            this.xFieldsData,
            _xfield.label,
            JSON.parse(JSON.stringify(formattedXFieldData[_xfield.label]))
          )

          if (
            previousImagePickerValue != null &&
            (Array.isArray(previousImagePickerValue) ||
              previousImagePickerValue instanceof File ||
              previousImagePickerValue instanceof Blob)
          ) {
            this.$set(
              this.xFieldsData[_xfield.label],
              'value',
              previousImagePickerValue
            )
          } else {
            try {
              if (this.xFieldsData[_xfield.label].value != '') {
                const parsedValue = JSON.parse(
                  this.xFieldsData[_xfield.label].value
                )
                const fieldDef = this.xFields[_xfield.label]
                const isPlainTextarea =
                  fieldDef &&
                  fieldDef.type == 'textarea' &&
                  !this.isImagePickerField(fieldDef)

                // b-textarea só aceita string/number; image-picker mantém array/object
                if (
                  isPlainTextarea &&
                  parsedValue != null &&
                  typeof parsedValue === 'object'
                ) {
                  this.$set(
                    this.xFieldsData[_xfield.label],
                    'value',
                    typeof this.xFieldsData[_xfield.label].value === 'string'
                      ? this.xFieldsData[_xfield.label].value
                      : JSON.stringify(parsedValue)
                  )
                } else {
                  this.$set(
                    this.xFieldsData[_xfield.label],
                    'value',
                    parsedValue
                  )
                }
              }
            } catch (error) {
              // console.warn('Error parsing options for field', _xfield.label,formattedXFieldData[_xfield.label].value,Object.prototype.toString.call(formattedXFieldData[_xfield.label].value), error)
            }
          }

          // Garante string em textareas comuns mesmo quando o valor já vem como objeto
          if (
            this.xFields[_xfield.label] &&
            this.xFields[_xfield.label].type == 'textarea' &&
            !this.isImagePickerField(this.xFields[_xfield.label])
          ) {
            const textareaValue = this.xFieldsData[_xfield.label].value
            if (textareaValue != null && typeof textareaValue === 'object') {
              this.$set(
                this.xFieldsData[_xfield.label],
                'value',
                JSON.stringify(textareaValue)
              )
            } else if (textareaValue == null) {
              this.$set(this.xFieldsData[_xfield.label], 'value', '')
            } else if (typeof textareaValue !== 'string') {
              this.$set(
                this.xFieldsData[_xfield.label],
                'value',
                String(textareaValue)
              )
            }
          }

          if (this.xFields[_xfield.label].type == 'radio') {
            const currentValue = this.xFieldsData[_xfield.label]
              ? this.xFieldsData[_xfield.label].value
              : ''
            this.setRadioIcon(
              _xfield.label,
              currentValue
            )
          }
        } else {
          //configuration fields
          this.xFields[_xfield.label].options =
            this.convertMetaType(_xfield)['options']
        }
      })

      let xFormFields = {}
      let ignorePage = false
      if (
        this.currentXFieldDetail &&
        this.currentXFieldDetail.currentXField &&
        Object.keys(this.xFields).indexOf(
          this.currentXFieldDetail.currentXField
        ) >= 0 &&
        this.currentXFieldDetail.currentXField.indexOf('page_') === 0
      ) {
        ignorePage = true
        this.xfieldDetails = this.currentXFieldDetail
      } else {
        ignorePage = false
        this.xfieldDetails = {}
      }
      let currentSessionClass = this.xfieldDetails.currentXField || 'page_1'
      Object.values(this.xFields).map((_xfield) => {
        if (
          _xfield.label == this.xfieldDetails.currentXField &&
          _xfield.label.indexOf('page_') === 0
        ) {
          ignorePage = false
          delete this.pages['pagecontrol_1']
          let pageNumber = currentSessionClass.split('_')[1]
          this.pages['pagecontrol_' + pageNumber] = [
            'base_buttons_session',
            'user_data_session',
            'page_' + pageNumber,
          ]
          this.pageControl = 'pagecontrol_' + pageNumber
        } else if (
          _xfield.label.indexOf('page_') === 0 &&
          this.xfieldDetails.currentXField
        ) {
          ignorePage = true
        }
        if (ignorePage) {
          return
        }
        if (_xfield.type != 'disabled') {
          if (_xfield.label && _xfield.label.indexOf('page_') === 0) {
            currentSessionClass = _xfield.label.toString()
            let page_number = currentSessionClass.split('_')[1]
            this.pages['pagecontrol_' + page_number] = [currentSessionClass]
          }
          if (!xFormFields[currentSessionClass]) {
            xFormFields[currentSessionClass] = []
          }

          if (enabledFields.indexOf(_xfield.label) >= 0 || !enabledFieldsFlag) {
            xFormFields[currentSessionClass].push(_xfield)
          } else {
            console.warn(
              'ignored field',
              _xfield.type,
              _xfield.label,
              JSON.stringify(_xfield)
            )
          }
        }
      })
      return Object.entries(xFormFields)
    },

    currentPage() {
      return this.pages[this.pageControl]
    },

    isBackable() {
      const pagesKeys = Object.keys(this.pages).sort()
      return pagesKeys.indexOf(this.pageControl) > 0
    },

    isNextable() {
      const pagesKeys = Object.keys(this.pages).sort()
      return (
        this.pages[pagesKeys[pagesKeys.indexOf(this.pageControl) + 1]].length &&
        pagesKeys.indexOf(this.pageControl) < pagesKeys.length - 1 &&
        !this.formErrors
      )
    },

    progressPercentage() {
      const pagesKeys = Object.keys(this.pages).sort()
      const pagesNumber = pagesKeys.length
      let currentPageIndex = pagesKeys.indexOf(this.pageControl) + 1
      let percentage =
        currentPageIndex == 0
          ? 0
          : (((currentPageIndex + 1) / pagesNumber) * 100).toFixed(2)

      return `${percentage}%`
    },
  },
  methods: {
    normalizeHexColor(value) {
      const raw = String(value == null ? '' : value).trim()
      const match = raw.match(/^#?([0-9a-fA-F]{6})$/)
      if (!match) return ''
      return `#${match[1].toLowerCase()}`
    },

    colorRaw(field) {
      const data = field && this.xFieldsData && this.xFieldsData[field.label]
      return data ? data.value : ''
    },

    colorIsSet(field) {
      return !!this.normalizeHexColor(this.colorRaw(field))
    },

    colorInputValue(field) {
      return this.normalizeHexColor(this.colorRaw(field)) || '#12576e'
    },

    colorInputLabel(field) {
      const hex = this.normalizeHexColor(this.colorRaw(field))
      return hex ? hex.toUpperCase() : 'Sem cor'
    },

    colorSwatchStyle(field) {
      const hex = this.normalizeHexColor(this.colorRaw(field))
      if (!hex) return {}
      return { backgroundColor: hex, borderColor: hex }
    },

    setColorValue(field, value) {
      const hex = this.normalizeHexColor(value)
      if (!hex || !field || !this.xFieldsData) return
      if (!this.xFieldsData[field.label]) {
        this.$set(this.xFieldsData, field.label, { value: hex })
        return
      }
      this.$set(this.xFieldsData[field.label], 'value', hex)
    },

    clearColorValue(field) {
      if (!field || !this.xFieldsData || !this.xFieldsData[field.label]) return
      this.$set(this.xFieldsData[field.label], 'value', '')
    },

    setImagePickerValue(fieldLabel, value) {
      // Files ficam em _imagePickerFiles (não reativo).
      // Em xFieldsData.value só metadados/URLs — evita o Vue 2 observar o File.
      const files = []
      const meta = []
      ;(Array.isArray(value) ? value : []).forEach((item) => {
        if (item && item.kind === 'file' && item.file instanceof File) {
          const pendingIndex = files.length
          files.push(item.file)
          meta.push({
            kind: 'file',
            pendingIndex,
            name: item.name || item.file.name,
          })
          return
        }
        if (item && item.kind === 'file' && item.file instanceof Blob) {
          const pendingIndex = files.length
          files.push(item.file)
          meta.push({
            kind: 'file',
            pendingIndex,
            name: item.name || 'image',
          })
          return
        }
        if (item && item.kind === 'url' && item.url) {
          meta.push({ kind: 'url', url: item.url, name: item.name || item.url })
          return
        }
        if (typeof item === 'string' && item) {
          meta.push({ kind: 'url', url: item, name: item })
        }
      })

      if (!this._imagePickerFiles) {
        this._imagePickerFiles = Object.create(null)
      }
      this._imagePickerFiles[fieldLabel] = files
      this.$set(this.xFieldsData[fieldLabel], 'value', meta)
    },

    getImagePickerValueForSave(fieldLabel, currentValue) {
      const files = (this._imagePickerFiles && this._imagePickerFiles[fieldLabel]) || []
      const meta = Array.isArray(currentValue) ? currentValue : []
      if (!meta.length && !files.length) return currentValue

      return meta.map((item) => {
        if (item && item.kind === 'file' && item.pendingIndex != null) {
          return {
            kind: 'file',
            file: files[item.pendingIndex],
            name: item.name,
          }
        }
        if (item && item.kind === 'url') {
          return { kind: 'url', url: item.url, name: item.name }
        }
        if (typeof item === 'string') {
          return { kind: 'url', url: item, name: item }
        }
        return item
      })
    },
    loadGalleryImagePicker(images, fieldLabel) {     
      let params =
        fieldLabel && this.xFieldsData[fieldLabel]
          ? this.xFieldsData[fieldLabel].value
          : ''
      return images
    },

    /**
     * Resolve options.load_function / load_function_param for select, text and textarea.
     * When load_function exists, replaces field.options with getOptionsData() result.
     * Returns parsed loadDataValues (or null when options has no special expressions).
     */
    applyLoadFunctionFromOptions(field) {
      const specialExpressions = [
        'load_function',
        'load_function_param',
        'default',
      ]

      if (
        !field ||
        Object.prototype.toString.call(field.options) !== '[object Object]'
      ) {
        return null
      }

      const hasSpecialExpression = Object.keys(field.options).find((option) => {
        return specialExpressions.includes(String(option).split('=')[0])
      })

      if (hasSpecialExpression == undefined) {
        return null
      }

      const loadDataValues = {}
      Object.keys(field.options).forEach((option) => {
        if (option != '') {
          const parts = String(option).split('=')
          loadDataValues[parts[0]] = parts[1]
        }
      })

      if (loadDataValues.load_function == undefined) {
        return loadDataValues
      }

      const paramKey = loadDataValues.load_function_param
      loadDataValues.load_function_param =
        paramKey && this.xFieldsData[paramKey]
          ? this.xFieldsData[paramKey].value
          : ''

      try {
        loadDataValues.load_function_param = JSON.parse(loadDataValues.load_function_param)
      } catch (error) {
      }

      const resolvedOptions = this.getOptionsData(
        loadDataValues.load_function,
        loadDataValues.load_function_param,
        field.label
      )

      if (Array.isArray(resolvedOptions)) {
        // Select com load_function (ex.: getRegionList) deve manter o array
        field.options = resolvedOptions
      } else if (resolvedOptions && typeof resolvedOptions === 'object') {
        // Textarea/image-picker: mescla metadados úteis (media_type, newType…)
        const meta = {}
        Object.keys(loadDataValues).forEach((key) => {
          if (
            !['load_function', 'load_function_param', 'default'].includes(key)
          ) {
            meta[key] = loadDataValues[key]
          }
        })
        field.options = {
          ...meta,
          ...resolvedOptions,
        }
      }

      return loadDataValues
    },

    fieldLabelText(field) {
      if (!field) return ''
      if (field.public_label !== undefined && field.public_label !== null) {
        return String(field.public_label).trim()
      }
      return field.label || ''
    },

    getDocMask(value) {
      const doc = String(value || '')
      if (/[A-Za-z]/.test(doc)) return 'AA######'
      const digits = doc.replace(/\D/g, '')
      if (digits.length > 11) return '##.###.###/####-##'
      return '###.###.###-##'
    },

    upperCaseXFieldDoc(label) {
      const field = this.xFieldsData[label]
      if (!field) return
      const value = String(field.value || '').toUpperCase()
      if (field.value !== value) this.$set(field, 'value', value)
    },

    decodeOption(option) {
      let parsedOption = option.split('#')
      //complex options with details
      if (parsedOption.length > 1) {
        option = {}
        option.id = parsedOption[0]
        parsedOption = parsedOption[1].replace(/'[^']*'/g, (match) =>
          match.replace(/;/g, ',')
        )
        parsedOption = parsedOption.replace(/\(([^()]*)\)/g, (match) =>
          match.replace(/;/g, ',')
        )
        parsedOption = parsedOption.split(';')
        parsedOption.forEach((item) => {
          item = item.split('=')
          option[item[0]] = item[1].replaceAll('_ ', ': ').replaceAll("'", '')
        })

        if (option.value == undefined) {
          option.value = option.id
        } else {
          option.id = option.value
        }
        if (option.label == undefined) {
          option.label = option.value
        }
        if (option.details != undefined) {
          option.details = option.details
        }
      } else {
        let parsedOption = option.split(':')
        parsedOption[0] = parsedOption[0].replaceAll('_ ', ': ')
        parsedOption[0] = parsedOption[0].replace(/\(([^()]*)\)/g, (match) =>
          match.replace(/;/g, ',')
        )
        if (parsedOption.length > 1) {
          parsedOption[1] = parsedOption[1].replaceAll('_ ', ': ')
          option = {}
          option.id = parsedOption[0]
          option.value = parsedOption[0]
          option.label = parsedOption[1]
        } else {
          option = {}
          option.id = parsedOption[0]
          option.value = parsedOption[0]
          option.label = parsedOption[0]
        }
      }
      return option
    },
    formatResponseTime(elapsedMs) {
      const totalSecs = Math.max(0, Math.floor(elapsedMs / 1000))
      const hours = Math.floor(totalSecs / 3600)
      const mins = Math.floor((totalSecs % 3600) / 60)
      const secs = totalSecs % 60
      const parts = []

      if (hours > 0) parts.push(`${hours} h`)
      if (mins > 0) parts.push(`${mins} mins`)
      if (secs > 0 || parts.length === 0) parts.push(`${secs} secs`)

      return `(${parts.join(' ')} )`
    },

    isImagePickerField(field) {
      if (!field) return false
      const options =
        field.options ||
        (field.label &&
          this.xFields[field.label] &&
          this.xFields[field.label].options)
      const type =
        field.type ||
        (field.label && this.xFields[field.label] && this.xFields[field.label].type)
      return type == 'textarea' && options && options.newType == 'image-picker'
    },

    openImagePicker(label) {
      if (!label || this.blockEdit) return
      this.$set(this.imagePickerVisible, label, true)
    },

    imagePickerCount(label) {
      const value =
        this.xFieldsData[label] && this.xFieldsData[label].value != null
          ? this.xFieldsData[label].value
          : []
      if (Array.isArray(value)) return value.length
      if (typeof value === 'string' && value.trim()) {
        try {
          const parsed = JSON.parse(value)
          return Array.isArray(parsed) ? parsed.length : 1
        } catch (error) {
          return 1
        }
      }
      return 0
    },

    saveXFieldsData() {
      const payload = JSON.parse(JSON.stringify(this.xFieldsData))

      // Reidrata image-picker com File reais guardados fora da reatividade
      Object.keys(this.xFieldsData || {}).forEach((key) => {
        const source = this.xFieldsData[key]
        const definition = this.xFields[key] || source
        if (!source || !this.isImagePickerField(definition)) return
        if (!payload[key]) {
          payload[key] = JSON.parse(JSON.stringify(source))
        }
        payload[key].value = this.getImagePickerValueForSave(key, source.value)
      })

      if (payload && payload.responseTime) {
        const openedAt = this.pageOpenedAt || Date.now()
        const formatted = this.formatResponseTime(Date.now() - openedAt)
        payload.responseTime.value = formatted
      }
      this.$emit('saveXFieldsData', {payload:payload,files:this._imagePickerFiles})
    },
    convertMetaType(field) {
      switch (field.type) {
        case 'file-image':
          // field.type = 'file'
          break
        case 'textarea-tinymce':
          field.type = 'textarea'
          break
        case 'text':
          this.applyLoadFunctionFromOptions(field.value)
          break
        case 'textarea':
          if(field.options.newType == undefined) {
            let loadDataValues = this.applyLoadFunctionFromOptions(field)
            field.options = {...field.options, ...loadDataValues}
          }
          break
        case 'mail':
          field.type = 'email'
          break
        case 'checkboxmultiple':
          field.multiple = true

          /**
           * Xfields syntaxes
           *
           *  special characters (: = # ,) can't be used in option text. use:
           *   underscore (_) as colon (:)
           *   semicolon (;) as virgula (,)
           *   simple quotes (') to wrap details
           *
           * clean:
           * ['Aldeia indígena', 'Assentamento (ex_ quilobolas, indígenas, etc)', 'Balneário', 'Cachoeira', 'Caverna', 'Comunidade Quilombola', 'Esportes de aventura', 'Fazenda', 'Lugares históricos', 'Manguezal', 'Museu ou Memorial', 'Nascentes', 'Outro', 'Parque', 'Poço', 'Praia', 'Produção agroecológica', 'Rio', 'Serras e montanhas', 'Sítios Arqueológicos', 'Trilha', 'Vilarejo', 'Vinícola']
           *
           * reference:
           * ['english:Inglês (ex_ US or UK)','french:Francês','german:Alemão','hebrew:Hebráico','italian:Italiano','japanese:Japonês', 'others:Outros', 'spanish:Espanhol']
           *
           * complex:
           * ["Experiência#value=Experiência;details='ex_ detalhes do que; significa um atrativo do tipo experiência';icon=/img/icons/what_to_do/atividades-na-agua.png;class='ni ni-cog'","Passeio#value=Passeio;details='detalhes do; que significa um atrativo do tipo passeio'"]
           */
          if (Array.isArray(field.options)) {
            const parsedOptions = field.options.filter(
              (opt) => opt && typeof opt === 'object' && opt.id != null
            )
            if (parsedOptions.length > 0) {
              field.options = parsedOptions
              break
            }
          }

          field.options = Object.values(field.options || {})
            .filter((option) => option != null && option !== '')
            .map((option) => {
              if (option && typeof option === 'object' && option.id != null) {
                return option
              }
              if (typeof option !== 'string') return null
              try {
                return this.decodeOption(option)
              } catch (error) {
                console.warn('parse xfields options syntax :>> ', error)
              }
              return null
            })
            .filter(Boolean)

          break
        case 'phone':
          field.type = 'tel'
          break
        case 'radio':
          /**
           * Xfields syntaxes
           *
           *  special characters (: = # ,) can't be used in option text. use:
           *   underscore (_) as colon (:)
           *   semicolon (;) as virgula (,)
           *   simple quotes (') to wrap details
           *
           * clean:
           * ['Aldeia indígena', 'Assentamento (ex_ quilobolas, indígenas, etc)', 'Balneário', 'Cachoeira', 'Caverna', 'Comunidade Quilombola', 'Esportes de aventura', 'Fazenda', 'Lugares históricos', 'Manguezal', 'Museu ou Memorial', 'Nascentes', 'Outro', 'Parque', 'Poço', 'Praia', 'Produção agroecológica', 'Rio', 'Serras e montanhas', 'Sítios Arqueológicos', 'Trilha', 'Vilarejo', 'Vinícola']
           *
           * reference:
           * ['english:Inglês (ex_ US or UK)','french:Francês','german:Alemão','hebrew:Hebráico','italian:Italiano','japanese:Japonês', 'others:Outros', 'spanish:Espanhol']
           *
           * complex:
           * ["Experiência#value=Experiência;label="Passeio do tipo experiência";details='ex_ detalhes do que; significa um atrativo do tipo experiência'","Passeio#value=Passeio;details='detalhes do; que significa um atrativo do tipo passeio'"]
           */
          if (Array.isArray(field.options)) {
            const parsedOptions = field.options.filter(
              (opt) => opt && typeof opt === 'object' && opt.id != null
            )
            if (parsedOptions.length > 0) {
              field.options = parsedOptions
              break
            }
          }

          field.options = Object.values(field.options || {})
            .filter((option) => option != null && option !== '')
            .map((option) => {
              if (option && typeof option === 'object' && option.id != null) {
                return option
              }
              if (typeof option !== 'string') return null
              try {
                return this.decodeOption(option)
              } catch (error) {
                console.warn('parse xfields options syntax :>> ', error)
              }
              return null
            })
            .filter(Boolean)

          if (
            field.options &&
            field.options.length > 0 &&
            field.options.some((option) => option.index)
          ) {
            field.options = field.options.sort((a, b) => a.index - b.index)
          }
          break
        case 'cpf':
          field.type = 'text'
          field.mask = 'document'
          break
        case 'cnpj':
          field.type = 'text'
          field.mask = 'document'
          break
        case 'site':
          field.type = 'text'
          break
        case 'select':
          /**
           * Parse select options
           * sintax:
           * spectial expression:
           *  ['load_function', 'load_function_params', 'default_value']
           */

          /**
           * Xfields syntaxes
           *
           *  special characters (: = # ,) can't be used in option text. use:
           *   underscore (_) as colon (:)
           *   semicolon (;) as virgula (,)
           *   simple quotes (') to wrap details
           *
           * clean:
           * ['Aldeia indígena', 'Assentamento (ex_ quilobolas, indígenas, etc)', 'Balneário', 'Cachoeira', 'Caverna', 'Comunidade Quilombola', 'Esportes de aventura', 'Fazenda', 'Lugares históricos', 'Manguezal', 'Museu ou Memorial', 'Nascentes', 'Outro', 'Parque', 'Poço', 'Praia', 'Produção agroecológica', 'Rio', 'Serras e montanhas', 'Sítios Arqueológicos', 'Trilha', 'Vilarejo', 'Vinícola']
           *
           * reference:
           * ['english:Inglês (ex_ US or UK)','french:Francês','german:Alemão','hebrew:Hebráico','italian:Italiano','japanese:Japonês', 'others:Outros', 'spanish:Espanhol']
           *
           * complex:
           * ["Experiência#value=Experiência;details='ex_ detalhes do que; significa um atrativo do tipo experiência'","Passeio#value=Passeio;details='detalhes do; que significa um atrativo do tipo passeio'"]
           */

          let specialExpressions = [
            'load_function',
            'load_function_param',
            'default',
          ]
          if (
            Object.prototype.toString.call(field.options) == '[object Object]'
          ) {
            let defaultValue = undefined

            // fix lower case value not matching with options keys
            if (field.value != null && field.value !== '') {
              let newValue = Object.keys(field.options).find((option) => {
                return (
                  String(option).toLowerCase() ==
                  String(field.value).toLowerCase()
                )
              })
              if (newValue) {
                field.value = newValue
              }
            }


            const loadDataValues = this.applyLoadFunctionFromOptions(field)

            defaultValue =
              loadDataValues && loadDataValues.default
                ? loadDataValues.default
                : undefined

            if (Array.isArray(field.options)) {
              // Options já resolvidas por load_function (ex.: getRegionList)
              field.multiple = false
            } else if (
              loadDataValues != undefined &&
              loadDataValues.load_function != undefined
            ) {
              field.multiple = false
            } else {
              field.multiple = true
              field.options = Object.values(field.options)
                .filter((item) => {
                  return (
                    typeof item === 'string' &&
                    item.trim() != '' &&
                    specialExpressions.indexOf(item.split('=')[0]) == -1
                  )
                })
                .map((item) => {
                  let option = item.replaceAll(';', ',')
                  option = option.split('=')
                  if (option[0] == 'default') {
                    if (field.value == '' || field.value == undefined) {
                      defaultValue = option[1]
                    }
                  } else {
                    option = {
                      id: `${option[0]}`,
                      value: option[0],
                      label: option[1] || option[0],
                    }
                  }

                  return option
                })
            }

            if (defaultValue != undefined) {
              field.value = defaultValue
            }
          }
          break
        case 'selectmultiple':
          if (field.value == '') {
            field.value = []
          }
          if (field.value && typeof field.value == 'object') {
            field.value = Object.values(field.value).map((v) => {
              if (undefined == v.id) {
                v.id = `_${v.value}`
              }
              return v
            })
          }

          if (field.options && typeof field.options == 'object') {
            field.options = Object.values(field.options).map((option, idx) => {
              if (typeof option == 'string') {
                option = option.split(':')
                if (undefined != option[1]) {
                  return {
                    id: `_${option[0]}`,
                    value: option[0],
                    label: option[1],
                  }
                } else {
                  let id = option[0]
                  id = id.split(' ')[0]
                  id = strNormalize(id, true, ' ')

                  return { id: `_${id}`, value: option[0], label: option[0] }
                }
              } else {
                option.id = `_${idx}`
                return option
              }
            })
          }
          field.type = 'select'
          field.multiple = true

          break

        case 'date':
          if (field.value != '' && field.value.indexOf('/') > 0) {
            field.value = field.value.split('/').reverse().join('-')
          }
          break

        case 'number-positive':
          try {
            field.min = undefined != field.options.min ? field.options.min : '0'
          } catch (error) {
            field.min = ''
          }
          field.type = 'number'
          break
        case 'disabled':
          break
        case 'text-currency':
          field.type = 'number'
          break
        case 'hidden_config':
          /**
           * page_x can have more details in details field, like page_title, page_subtitle, icon_class
           *
           *
           * sintax:
           * page_title=Informações Básicas;page_subtitle=informações gerais sobre o atrativo
           * Página A#page_title='Informações básicas; intermediárias e avançadas';page_subtitle=informações gerais sobre o atrativo
           *
           */

          field.options = Object.values(field.options || {})
            .filter((option) => option != null && option !== '')
            .map((option) => {
              if (option && typeof option === 'object' && option.id != null) {
                return option
              }
              if (typeof option !== 'string') return null
              try {
                return this.decodeOption(option)
              } catch (error) {
                console.warn(
                  'parse xfields options syntax hidden_config :>> ',
                  error
                )
              }
              return null
            })
          break
        default:
          break
      }

      // TODO: remove this after testing
      if (
        [
          'sivalluzibicoara060@gmail.com',
          'gestorsonho@janoo.com.br',
          'gestorjanoo@janoo.com.br',
          'parnadiamantina@icmbio.gov.br',
        ].includes(this.loggedUser.username) ||
        this.$route.query.edit == 'true' ||
        process.env.NODE_ENV === 'development'
      ) {
        const currentDisplay =
          Number(this.xFields[field.label].add_display) || 0
        if (currentDisplay === 0) {
          this.xFields[field.label].add_display = 2
        } else if (currentDisplay === 1) {
          this.xFields[field.label].add_display = 3
        }
        // this.xFields[field.label].display = "1"
      }
      return field
    },

    handleDynamicOptions(field, dynamicValues) {
      let loadDataValues = false
      let loadDataCumulative = false
      let _options = []
      if (Object.keys(field.options).indexOf('dynamiclabel') >= 0) {
        loadDataValues = field.options['dynamiclabel'].split(':')[1]
      }
      if (Object.keys(field.options).indexOf('cumulative') >= 0) {
        loadDataCumulative = field.options['cumulative'].split(':')[1]
        if (loadDataCumulative) {
          field.cumulative = true
        }
      }

      if (dynamicValues[loadDataValues]) {
        dynamicValues[loadDataValues].forEach((element) => {
          _options.push({
            id: element.id,
            value: element.id,
            label: element.name,
          })
        })
        field.options = _options
      }
      return field
    },
    closeModal() {
      this.unlockBodyScroll()
      this.$emit('closeEditXFieldModal')
    },
    lockBodyScroll() {
      this._previousBodyOverflow = document.body.style.overflow
      this._previousHtmlOverflow = document.documentElement.style.overflow
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    },
    unlockBodyScroll() {
      document.body.style.overflow =
        this._previousBodyOverflow != null ? this._previousBodyOverflow : ''
      document.documentElement.style.overflow =
        this._previousHtmlOverflow != null ? this._previousHtmlOverflow : ''
    },
    selectMultipleValue(type, fieldLabel, isMultiple, fieldValue, value) {
      if (
        Object.prototype.toString.call(this.xFieldsData[fieldLabel]['value']) !=
        '[object Array]'
      ) {
        try {
          this.xFieldsData[fieldLabel]['value'] = JSON.parse(
            this.xFieldsData[fieldLabel]['value']
          )
        } catch (error) {
          this.xFieldsData[fieldLabel]['value'] = []
        }
      }
      if (value != false) {
        this.xFieldsData[fieldLabel]['value'].push(fieldValue)
      } else {
        this.xFieldsData[fieldLabel]['value'] = this.xFieldsData[fieldLabel][
          'value'
        ].filter((item) => item != fieldValue)
      }
    },
    setRadioIcon(fieldLabel, value) {
      const options = this.getSafeFieldOptions({ label: fieldLabel })
      options.forEach((option) => {
        if (!option || !option.class) return
        if (!option.base_class) {
          this.$set(option, 'base_class', option.class)
        }
        const selected = String(option.id) === String(value)
        const colorClass = selected ? 'radio-selected-item-color' :''
        this.$set(
          option,
          'class',
          selected
            ? (option.selected_class || option.base_class) + ' ' + colorClass || option.base_class
            : option.base_class
        )
      })
    },
    hasIconOptions(field) {
      if (!field) return false
      if (field.label === 'activity_categories' || field.label === 'what_to_do')
        return true
      const options = this.getSafeFieldOptions(field)
      return options.some((opt) => opt && opt.icon)
    },
    getSafeFieldOptions(field) {
      const source =
        (this.xFields[field.label] && this.xFields[field.label].options) ||
        (field && field.options) ||
        (this.xFieldsData[field.label] &&
          this.xFieldsData[field.label].options) ||
        []
      const list = Array.isArray(source) ? source : Object.values(source || {})

      return list.filter(
        (option) => option && typeof option === 'object' && option.id != null
      )
    },
    isRadioIconMulti(field) {
      if (!this.isPageLayout || !field || field.type !== 'radio') return false
      const options = this.getSafeFieldOptions(field)
      if (options.length < 3) return false
      return options.some((opt) => opt && opt.class)
    },
    getCategorySvg(labelText) {
      if (!labelText) return ''
      const normalized = strNormalize(labelText.toString(), true)

      if (normalized.includes('cachoeira')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M4 3h16v4c-2 0-3 2-5 2s-3-2-5-2-3 2-6 2V3z"/><path d="M7 11v8"/><path d="M11 11v10"/><path d="M15 11v7"/><path d="M3 21c3-1 6-1 9 0s6 1 9 0"/></svg>`
      }
      if (normalized.includes('caverna') || normalized.includes('gruta')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 20h18"/><path d="M3 20C3 11 7 4 13 4c5 0 8 5 8 16"/><path d="M8 20c0-4 2-7 5-7s5 3 5 7"/></svg>`
      }
      if (normalized.includes('poco') || normalized.includes('lagoa')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="12" rx="9" ry="5.5"/><path d="M5 12c0 2.8 3.1 5 7 5s7-2.2 7-5"/><path d="M12 6.5v5.5"/></svg>`
      }
      if (
        normalized.includes('trilha') ||
        normalized.includes('caminhada') ||
        normalized.includes('trekking')
      ) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19l4-14 4 8 4-4 4 10"/><path d="M4 19h16"/><circle cx="12" cy="5" r="1.5"/></svg>`
      }
      if (
        normalized.includes('serra') ||
        normalized.includes('montanha') ||
        normalized.includes('morro')
      ) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M2 20h20"/><path d="M4 20l7-13 4 7 2-3 5 9"/><path d="M8.5 12l2.5 3 3-2.5"/></svg>`
      }
      if (
        normalized.includes('praia') ||
        normalized.includes('litoral') ||
        normalized.includes('costa')
      ) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M2 19c3-1 6-1 9 0s6 1 9 0"/><path d="M2 22c3-1 6-1 9 0s6 1 9 0"/><path d="M17.5 10c0-4-3.5-7-7.5-7-1.5 0-3 .5-4 1.5"/><path d="M10 3v13"/><path d="M10 16l4-7"/></svg>`
      }
      if (normalized.includes('rio')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6c3 2 6 2 9 0s6-2 9 0"/><path d="M3 12c3 2 6 2 9 0s6-2 9 0"/><path d="M3 18c3 2 6 2 9 0s6-2 9 0"/></svg>`
      }
      if (
        normalized.includes('parque') ||
        normalized.includes('reserva') ||
        normalized.includes('floresta')
      ) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L7 9h3l-3 6h10l-3-6h3L12 2z"/><path d="M12 15v7"/></svg>`
      }
      if (
        normalized.includes('aldeia') ||
        normalized.includes('indigena') ||
        normalized.includes('quilomb')
      ) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M12 3l8 18H4L12 3z"/><path d="M10 21l2-5 2 5"/><circle cx="12" cy="11" r="1.5"/></svg>`
      }
      if (
        normalized.includes('assentamento') ||
        normalized.includes('vilarejo') ||
        normalized.includes('vila')
      ) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10l5-4 5 4v9H3V10z"/><path d="M13 13l4-3 4 3v6h-8v-6z"/><path d="M6 19v-4h2v4"/></svg>`
      }
      if (normalized.includes('balneario')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="5" r="3"/><path d="M3 16c2.5-1 5-1 7.5 0s5 1 7.5 0 3-.5 3-.5"/><path d="M3 20c2.5-1 5-1 7.5 0s5 1 7.5 0 3-.5 3-.5"/><path d="M7 11h10"/></svg>`
      }
      if (normalized.includes('esporte') || normalized.includes('aventura')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polygon points="12,6 15,12 12,10 9,12" fill="currentColor"/><polygon points="12,18 9,12 12,14 15,12"/></svg>`
      }
      if (normalized.includes('fazenda') || normalized.includes('sitio')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10l9-6 9 6v10H3V10z"/><path d="M8 20v-7h8v7"/><line x1="8" y1="10" x2="16" y2="10"/></svg>`
      }
      if (
        normalized.includes('historico') ||
        normalized.includes('arqueolog') ||
        normalized.includes('patrimonio')
      ) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M4 18h16"/><path d="M6 18V9"/><path d="M10 18V9"/><path d="M14 18V9"/><path d="M18 18V9"/><path d="M2 9l10-6 10 6H2z"/></svg>`
      }
      if (normalized.includes('manguezal') || normalized.includes('mangue')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v10"/><path d="M12 13C8 13 5 16 3 21"/><path d="M12 13c4 0 7 3 9 8"/><path d="M12 9C9 9 7 7 6 4"/><path d="M12 9c3 0 5-2 6-5"/></svg>`
      }
      if (normalized.includes('museu') || normalized.includes('memorial')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V10"/><path d="M19 21V10"/><path d="M9 21v-7h6v7"/><path d="M2 10l10-7 10 7H2z"/></svg>`
      }
      if (normalized.includes('nascente')) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3C8 8 6 12 6 15a6 6 0 0 0 12 0c0-3-2-7-6-12z"/><path d="M9 16a3 3 0 0 0 3 3"/></svg>`
      }
      if (
        normalized.includes('agroecolog') ||
        normalized.includes('organico') ||
        normalized.includes('planta')
      ) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22v-9"/><path d="M12 13c-4-4-8-2-9 4 4 1 8-1 9-4z"/><path d="M12 9c3-4 7-4 9-2-1 4-4 6-9 2z"/></svg>`
      }
      if (
        normalized.includes('vinicol') ||
        normalized.includes('vinho') ||
        normalized.includes('uva')
      ) {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M8 22h8"/><path d="M12 15v7"/><path d="M7 3h10v5a5 5 0 0 1-10 0V3z"/><path d="M7 6h10"/></svg>`
      }
      return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polygon points="12,7 14.5,12 12,10.5 9.5,12"/></svg>`
    },
    validateField() {
      this.fieldErrors = {}
      const targets = document.querySelectorAll('[bc_label]')
      targets.forEach((target) => {
        const fieldName = target.name || target.getAttribute('bc_label')
        let isValid = true
        let errorMessage =
          target.getAttribute('aria-invalid') ||
          'Valor inválido para o campo ' + fieldName

        if (!target.value && target.required) {
          isValid = false
        }

        if (target.getAttribute('bc_label') === 'mailaddress') {
          isValid = this.validEmail(target.value)
          errorMessage = 'E-mail inválido!'
        }

        this.$set(this.fieldErrors, fieldName, !isValid ? errorMessage : '')
        this.$emit('emitFormErrors', !isValid)

        if (!isValid) {
          this.$notify({
            message: errorMessage,
            duration: 5000,
            type: 'error',
            overlap: false,
          })
        } else {
          this.$emit('emitFormWaiting', false)
        }
      })
    },
    getFlagEmoji(countryCode) {
      const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map((char) => 127397 + char.charCodeAt())
      return String.fromCodePoint(...codePoints)
    },
    onFileChange(e) {
      const slug = e.target.name
      const file = e.target.files && e.target.files[0]
      if (!file) return

      const publicLabelAttr =
        e.target.attributes.public_label &&
        e.target.attributes.public_label.nodeValue
      const tmpFiles = {}
      tmpFiles[slug] = {
        slug,
        public_label: publicLabelAttr || slug,
        file,
      }
      this.$emit('emitTmpFiles', tmpFiles)

      if (file.type && file.type.indexOf('image/') === 0) {
        if (this.fileImageLocalPreviews[slug]) {
          URL.revokeObjectURL(this.fileImageLocalPreviews[slug])
        }
        this.$set(
          this.fileImageLocalPreviews,
          slug,
          URL.createObjectURL(file)
        )
      }
    },

    isDirectImageUrl(value) {
      if (!value || typeof value !== 'string') return false
      return (
        value.indexOf('http://') === 0 ||
        value.indexOf('https://') === 0 ||
        value.indexOf('blob:') === 0 ||
        value.indexOf('data:image') === 0
      )
    },

    getFileImagePreview(field) {
      if (!field || !field.label) return null
      const label = field.label

      if (this.fileImageLocalPreviews[label]) {
        return this.fileImageLocalPreviews[label]
      }
      if (this.fileImageRemotePreviews[label]) {
        return this.fileImageRemotePreviews[label]
      }

      const value =
        this.xFieldsData[label] && this.xFieldsData[label].value
          ? this.xFieldsData[label].value
          : ''

      if (!value || typeof value !== 'string') return null

      if (this.isDirectImageUrl(value)) {
        if (value.indexOf('google.com') > 0) {
          const match = /d\/([^/]+)\/view/.exec(value)
          if (match && match[1]) {
            return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w800`
          }
        }
        return value
      }

      this.loadRemoteFileImage(label, value)
      return null
    },

    async loadRemoteFileImage(label, path) {
      if (!label || !path) return
      if (this.fileImageLoading[label] || this.fileImageRemotePreviews[label]) {
        return
      }

      this.$set(this.fileImageLoading, label, true)
      try {
        const objectUrl = await fetchFileObjectUrl(path)
        if (!objectUrl) {
          console.warn('Não foi possível carregar a imagem do campo', label)
          return
        }
        this.$set(this.fileImageRemotePreviews, label, objectUrl)
      } catch (error) {
        console.warn('Não foi possível carregar a imagem do campo', label, error)
      } finally {
        this.$set(this.fileImageLoading, label, false)
      }
    },

    removeFileImage(field) {
      if (!field || !field.label || this.blockEdit) return
      const label = field.label

      if (this.fileImageLocalPreviews[label]) {
        URL.revokeObjectURL(this.fileImageLocalPreviews[label])
        this.$delete(this.fileImageLocalPreviews, label)
      }
      if (this.fileImageRemotePreviews[label]) {
        URL.revokeObjectURL(this.fileImageRemotePreviews[label])
        this.$delete(this.fileImageRemotePreviews, label)
      }

      if (this.xFieldsData[label]) {
        this.$set(this.xFieldsData[label], 'value', '')
      }

      this.$emit('emitTmpFiles', { [label]: null })
    },

    revokeAllFileImagePreviews() {
      Object.keys(this.fileImageLocalPreviews || {}).forEach((key) => {
        URL.revokeObjectURL(this.fileImageLocalPreviews[key])
      })
      Object.keys(this.fileImageRemotePreviews || {}).forEach((key) => {
        URL.revokeObjectURL(this.fileImageRemotePreviews[key])
      })
      this.fileImageLocalPreviews = {}
      this.fileImageRemotePreviews = {}
      this.fileImageLoading = {}
    },

    validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    previousPage() {
      if (this.isBackable) {
        const pagesKeys = Object.keys(this.pages).sort()
        let currentPageIndex = pagesKeys.indexOf(this.pageControl)
        if (currentPageIndex > 0) {
          this.pageControl = pagesKeys[--currentPageIndex]
        }
        if (currentPageIndex == 0) {
          this.disablePreviousButton = true
        }
      }
      document.getElementById('xfield-panel-body').scrollTo(0, 0)
    },

    nextPage() {
      const invalidFields = document.querySelectorAll(
        "[required]:not([valid='true'])"
      )

      if (invalidFields.length > 0) {
        this.formErrors = true

        setTimeout(() => {
          invalidFields[0].focus()
          invalidFields[0].blur()
        }, 0)

        this.formWaiting = false
        return false
      }

      this.formErrors = false

      if (this.isNextable) {
        this.disablePreviousButton = false
        const pagesKeys = Object.keys(this.pages).sort()
        const pagesNumber = pagesKeys.length
        let currentPageIndex = pagesKeys.indexOf(this.pageControl)

        if (currentPageIndex >= 0 && currentPageIndex < pagesNumber - 1) {
          this.pageControl = pagesKeys[++currentPageIndex]
        }
      }
      document.getElementById('xfield-panel-body').scrollTo(0, 0)
    },
    isOptionChecked(fieldLabel, optionValue) {
      if (
        Object.prototype.toString.call(this.xFieldsData[fieldLabel]['value']) ==
        '[object Array]'
      ) {
        return (
          this.xFieldsData[fieldLabel]['value'].filter(
            (item) => item == optionValue.id
          ).length > 0
        )
      } else {
        return this.xFieldsData[fieldLabel]['value'] == optionValue
      }
    },
    getOptionsData(optionsLabel, optionsParam, fieldLabel) {
      let options = []
      switch (optionsLabel) {
        case 'getRegionList':
          options = [
            {
              label: 'Região Norte',
              options: [
                {
                  value: 'Acre',
                  text: 'Acre: Caminhos da Revolução, Caminhos do Pacífico',
                },
                {
                  value: 'Amapá',
                  text: 'Amapá: Oiapoque, Guianas, e Guiana Francesa, Caminhos do Marabaixo',
                },
                {
                  value: 'Amazonas',
                  text: 'Amazonas: Caminhos de Anavilhanas, Caminhos do Rio Negro, Caminhos do Solimões, Caminhos do Madeira',
                },
                {
                  value: 'Pará',
                  text: 'Pará: Belém, Tapajós, Marajó, Araguaia-Tocantins, Xingu, Amazônia Atlântica, Rios, Lagos e Florestas',
                },
                {
                  value: 'Rondônia',
                  text: 'Rondônia: Caminho das Águas, Caminho do Ouro',
                },
                { value: 'Roraima', text: 'Roraima: Extremo Norte' },
                {
                  value: 'Tocantins',
                  text: 'Tocantins: Serras e Lagos, Encantos do Jalapão',
                },
              ],
            },
            {
              label: 'Região Nordeste',
              options: [
                {
                  value: 'Alagoas',
                  text: 'Alagoas: Costa dos Corais, Lagoas e Mares do Sul, Caminhos do São Francisco',
                },
                {
                  value: 'Bahia',
                  text: 'Bahia: Baía de Todos-os-Santos, Caminhos do Oeste, Caminhos do Sertão, Caminhos do Jiquiriçá, Caminhos do Sudoeste, Costa dos Coqueiros, Costa das Baleias, Costa do Cacau, Costa do Descobrimento, Chapada Diamantina, Recôncavo, Vale do São Francisco',
                },
                {
                  value: 'Ceará',
                  text: 'Ceará: Litoral Oeste, Litoral Leste, Ibiapaba, Cariri, Sertão Central, Sertão dos Inhamuns',
                },
                {
                  value: 'Maranhão',
                  text: 'Maranhão: Chapada das Mesas, Munim, Floresta dos Guarás, Lagos e Campos Floridos, Lençóis Maranhenses, Cocais, Amazônia Maranhense, Delta das Américas',
                },
                {
                  value: 'Paraíba',
                  text: 'Paraíba: Costa das Piscinas, Cariri, Sertão, Brejo, Agreste',
                },
                {
                  value: 'Pernambuco',
                  text: 'Pernambuco: Costa dos Arrecifes, Encantos do Agreste, Vale do São Francisco, Chapada do Araripe, Sertão e Trilhas',
                },
                {
                  value: 'Piauí',
                  text: 'Piauí: Litoral, Chapada das Mangabeiras, Polo das Nascentes, Polo das Origens, Serra da Capivara, Delta do Parnaíba',
                },
                {
                  value: 'Rio Grande do Norte',
                  text: 'Rio Grande do Norte: Polo Costa das Dunas, Polo Costa Branca, Polo Agreste/Trairi, Polo Seridó',
                },
                {
                  value: 'Sergipe',
                  text: 'Sergipe: Costa dos Coqueirais, Rota do Sertão',
                },
              ],
            },
            {
              label: 'Região Centro-Oeste',
              options: [
                {
                  value: 'Distrito Federal',
                  text: 'Distrito Federal: Brasília, Região Integrada de Desenvolvimento do Distrito Federal e Entorno (RIDE)',
                },
                {
                  value: 'Goiás',
                  text: 'Goiás: Chapada dos Veadeiros, Águas Quentes, Ouro e Cristais, Corredores das Águas, Caminho dos Bandeirantes',
                },
                {
                  value: 'Mato Grosso',
                  text: 'Mato Grosso: Pantanal, Chapada dos Guimarães, Vale do Guaporé, Araguaia, Norte',
                },
                {
                  value: 'Mato Grosso do Sul',
                  text: 'Mato Grosso do Sul: Pantanal, Caminho dos Ipês, Bonito e Serra da Bodoquena',
                },
              ],
            },
            {
              label: 'Região Sudeste',
              options: [
                {
                  value: 'Espírito Santo',
                  text: 'Espírito Santo: Costa e Imigração, Montanhas Capixabas, Metropolitana, Doce Pontões e Lagoas',
                },
                {
                  value: 'Minas Gerais',
                  text: 'Minas Gerais: Coração das Gerais, Rota do Ouro, Sul, Centro-Oeste, Triângulo Mineiro, Vale do Aço, Vale do Jequitinhonha, Zona da Mata, Mantiqueira, Cerrado Mineiro',
                },
                {
                  value: 'Rio de Janeiro',
                  text: 'Rio de Janeiro: Costa Verde, Costa do Sol, Metropolitana, Serra Verde Imperial, Agulhas Negras, Vale do Café',
                },
                {
                  value: 'São Paulo',
                  text: 'São Paulo: Circuito das Águas, Circuito das Frutas, Serra Azul, Mantiqueira, Costa da Mata Atlântica, Grande São Paulo, Rios, Lagos e Florestas',
                },
              ],
            },
            {
              label: 'Região Sul',
              options: [
                {
                  value: 'Paraná',
                  text: 'Paraná: Litoral, Campos Gerais, Região Metropolitana de Curitiba, Cataratas e Caminhos do Iguaçu, Rota dos Tropeiros, Terra dos Pinheirais',
                },
                {
                  value: 'Rio Grande do Sul',
                  text: 'Rio Grande do Sul: Hortênsias, Uva e Vinho, Litoral, Pampa, Missões, Águas e Pedras',
                },
                {
                  value: 'Santa Catarina',
                  text: 'Santa Catarina: Vale Europeu, Caminhos dos Príncipes, Serra Catarinense, Costa Verde e Mar, Grande Florianópolis, Encantos do Sul',
                },
              ],
            },
          ]
          break
        case 'getCitiesList':
          options = [
            'Água Doce do Norte-BA',
            'Andaraí-BA',
            'Aracruz-BA',
            'Esplanada-BA',
            'Ibicoara-BA',
            'Iraquara-BA',
            'Itaetê-BA',
            'Lençóis-BA',
            'Mucugê-BA',
            'Ourolândia-BA',
            'Palmeiras-BA',
            'Piatã-BA',
            'Rio de Contas-BA',
            'Seabra-BA',
            'Vera Cruz-BA',
            'Wagner-BA',
          ]
          break
        case 'getStatesList':
          options = {
            AC: 'Acre',
            AL: 'Alagoas',
            AP: 'Amapá',
            AM: 'Amazonas',
            BA: 'Bahia',
            CE: 'Ceará',
            DF: 'Distrito Federal',
            ES: 'Espírito Santo',
            GO: 'Goiás',
            MA: 'Maranhão',
            MT: 'Mato Grosso',
            MS: 'Mato Grosso do Sul',
            MG: 'Minas Gerais',
            PA: 'Pará',
            PB: 'Paraíba',
            PR: 'Paraná',
            PE: 'Pernambuco',
            PI: 'Piauí',
            RJ: 'Rio de Janeiro',
            RN: 'Rio Grande do Norte',
            RS: 'Rio Grande do Sul',
            RO: 'Rondônia',
            RR: 'Roraima',
            SC: 'Santa Catarina',
            SP: 'São Paulo',
            SE: 'Sergipe',
            TO: 'Tocantins',
          }
          break
        case 'loadGalleryImagePicker':
          options = {
            newType: 'image-picker',
          }
          break
        default:
          options = [
            {
              id: '--',
              value: '--',
              text: '--',
            },
          ]
          break
      }
      return options
    },
  },
  watch: {},
  mounted() {
    this.pageOpenedAt = Date.now()

    if (!this.isPageLayout) {
      this.lockBodyScroll()
    }

    this.xfieldDetails = this.currentXFieldDetail || {}
    
  },
  beforeDestroy() {
    if (!this.isPageLayout) {
      this.unlockBodyScroll()
    }
  },
}
</script>

<style lang="css">
.xfield-color {
  display: flex;
  align-items: center;
  gap: 12px;
}

.xfield-color-swatch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 32px;
  margin: 0;
  border: 1px dashed #adb5bd;
  border-radius: 6px;
  background-color: #fff;
  background-image: linear-gradient(45deg, #e9ecef 25%, transparent 25%),
    linear-gradient(-45deg, #e9ecef 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #e9ecef 75%),
    linear-gradient(-45deg, transparent 75%, #e9ecef 75%);
  background-size: 12px 12px;
  background-position: 0 0, 0 6px, 6px -6px, -6px 0;
  overflow: hidden;
  cursor: pointer;
}

.xfield-color-swatch--set {
  background-image: none;
  border-style: solid;
}

.xfield-color-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  opacity: 0;
  cursor: pointer;
}

.xfield-color-hex {
  color: #525f7f;
  font-size: 0.875rem;
}

.xfield-color-clear {
  border: 0;
  background: transparent;
  padding: 0;
  color: #12576e;
  font-size: 0.875rem;
  cursor: pointer;
}

.xfield-file-image {
  width: 100%;
}

.xfield-file-image-preview {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
}

.xfield-file-image-thumb {
  display: block;
  max-width: 100%;
  max-height: 220px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 6px;
  background: #f7fafc;
}

.xfield-file-image-remove {
  align-self: flex-start;
}

.form-control-label {
  color: #2d3748 !important;
  font-size: .9rem;
  margin-bottom: 14px;
  font-weight: normal;
  display: block;
}

/* Radio Card Boxes (Tipo de atrativo) */
.radio_session {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.radio-card-box {
  display: flex;
  flex-direction: column;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 16px 20px;
  cursor: pointer;
  background-color: #fff;
  transition: all 0.2s ease-in-out;
  position: relative;
  width: 100%;
  margin-bottom: 0;
}

.radio-selected-item-color,.radio-selected-item-color::before {
  -webkit-text-fill-color: #12576e !important;
  -webkit-text-stroke: 0px #12576e !important;
}


.radio-class-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid #dcdfe6;
  border-radius: 8px;
  line-height: 1;
  padding: 5px;
  cursor: pointer;
  background-color: #fff;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  position: relative;
  width: fit-content;
  margin: 0 5px 0 0;
  text-align: center;
  vertical-align: middle;
}

.radio-class-box:hover {
  border-color: #12576e;
  background-color: #fafcfd;
}
.radio-class-box.selected {
  border: 1.5px solid #12576e;
  background-color: #f3f9fb;
  box-shadow: 0 1px 3px rgba(20, 103, 130, 0.1);
}
  /* 

.radio-class-box.selected i,
.radio-class-box.selected i::before {
  -webkit-text-fill-color: #12576e;
  -webkit-text-stroke: 0px #12576e;
}

.radio-class-box.selected i.no-star,
.radio-class-box.selected i.no-star::before {
  -webkit-text-fill-color: #12576e;
  -webkit-text-stroke: 1px #12576e;
  paint-order: stroke fill;
} */

.radio-class-box i,
.radio-class-box i::before {
  display: block;
  margin: 0 auto;
  text-align: center;
  -webkit-text-fill-color: #a5a5a5;
  -webkit-text-stroke: 0px #a5a5a5;
  paint-order: stroke fill;
}

.radio-class-box .radio-card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0;
  padding: 0;
}

.radio-class-box .radio-card-header > div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  line-height: 1;
}
.radio-card-box:hover {
  border-color: #12576e;
  background-color: #fafcfd;
}

.radio-card-box.selected {
  border: 1.5px solid #12576e;
  background-color: #f3f9fb;
  box-shadow: 0 1px 3px rgba(20, 103, 130, 0.1);
}

.radio-card-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.radio-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a202c;
}

.badge-ver-exemplo {
  background-color: #12576e;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  letter-spacing: 0.3px;
}

.radio-card-details {
  font-size: 13px;
  color: #718096;
  line-height: 1.45;
  margin-top: 8px;
}

/* Checkbox Multiple Icon Grid (Categorias / O que ver / O que fazer) */
.checkboxmultiple_grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));
  gap: 10px;
  width: 100%;
}

.icon-checkbox-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 12px 6px;
  cursor: pointer;
  background-color: #fff;
  min-height: 94px;
  transition: all 0.2s ease-in-out;
  position: relative;
  margin-bottom: 0;
  user-select: none;
}

.icon-checkbox-box:hover {
  border-color: #12576e;
  background-color: #fafcfd;
}

.icon-checkbox-box.selected {
  border: 2px solid #12576e;
  background-color: #f3f9fb;
  color: #12576e;
}

.icon-checkbox-img-wrap {
  display: flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

.icon-title-img-wrap {
  display: table-cell;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

.icon-checkbox-svg-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #4a5568;
  transition: color 0.2s ease;
}

.icon-checkbox-box:hover .icon-checkbox-svg-wrap,
.icon-checkbox-box.selected .icon-checkbox-svg-wrap {
  color: #12576e;
}

.icon-checkbox-svg-wrap svg {
  width: 26px;
  height: 26px;
  stroke-width: 1.8;
}

.icon-checkbox-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.icon-checkbox-placeholder {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  font-size: 20px;
  color: #a0aec0;
}

.icon-checkbox-label {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.25;
  color: #2d3748;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.icon-checkbox-box.selected .icon-checkbox-label {
  font-weight: 700;
  color: #12576e;
}

.icon-checkbox-details {
  display: block;
  font-size: 10px;
  color: #a0aec0;
  margin-top: 2px;
}

.hidden-custom-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
  margin: 0;
}

/* Checkbox List 3 Columns (Opções em lista textual / sem ícones) */
.checkbox_list_3col {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 100%;
}

@media (max-width: 1100px) {
  .checkbox_list_3col {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .checkbox_list_3col {
    grid-template-columns: 1fr;
  }
  .xfield-edit-sidebar,
  .product-details-sidebar {
    width: 100% !important;
    z-index: 1001 !important;
  }
}

.checkbox-list-card {
  display: flex;
  align-items: flex-start;
  background-color: #f8fafc;
  border: 1px solid #edf2f7;
  border-radius: 6px;
  padding: 10px 12px;
  cursor: pointer;
  margin-bottom: 0;
  transition: all 0.2s ease;
  user-select: none;
  gap: 10px;
  width: 100%;
}

.single-checkbox-card {
  max-width: 100%;
}

.checkbox-list-card:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.checkbox-list-card.selected {
  background-color: #f0f7f9;
  border-color: #12576e;
}

.custom-checkbox-indicator {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}

.custom-checkbox-input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin: 0;
  z-index: 2;
}

.custom-checkbox-box {
  width: 18px;
  height: 18px;
  border: 1.5px solid #94a3b8;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.checkbox-list-card:hover .custom-checkbox-box {
  border-color: #12576e;
}

.checkbox-list-card.selected .custom-checkbox-box {
  background-color: #12576e;
  border-color: #12576e;
  color: #fff;
}

.check-svg {
  width: 12px;
  height: 12px;
  stroke: #fff;
}

.checkbox-list-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

.checkbox-list-title {
  font-size: 13.5px;
  font-weight: 500;
  color: #1e293b;
  line-height: 1.35;
}

.checkbox-list-card.selected .checkbox-list-title {
  font-weight: 600;
  color: #0f4557;
}

.checkbox-list-details {
  font-size: 11.5px;
  color: #64748b;
  line-height: 1.3;
  margin-top: 3px;
}

/* Footer progress and buttons */
.footer-progress-bar {
  background-color: #e2e8f0;
  height: 4px;
  border-radius: 2px;
  width: 100%;
  overflow: hidden;
}

.footer-progress-bar-inside {
  background-color: #12576e;
  height: 100%;
  transition: width 0.3s ease;
}

.btn-save-exit {
  font-size: 13px;
  padding: 10px 14px;
  border-radius: 6px;
  transition: opacity 0.2s;
}

.btn-save-exit:hover {
  opacity: 0.9;
  color: #fff;
}

.btn-outline-nav {
  background-color: #fff;
  color: #12576e;
  border: 1px solid #12576e;
  font-size: 13px;
  padding: 10px 14px;
  border-radius: 6px;
  transition: all 0.2s;
}

.btn-outline-nav:hover:not(.disabled) {
  background-color: #f3f9fb;
  color: #12576e;
}

.btn-primary-nav {
  background-color: #12576e;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  padding: 10px 14px;
  border-radius: 6px;
  border: none;
  transition: opacity 0.2s;
}

.btn-primary-nav:hover:not(.disabled) {
  opacity: 0.9;
  color: #fff;
}

.xfield-edit-sidebar .page_title {
  position: fixed;
  top: 10.5dvh;
  z-index: 1;
  background: #fff;
}

.xfield-edit-sidebar .page_title small {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 10px;
  max-width: calc(100% - 2em);
  margin-bottom: 10px;
}

.xfield-edit-sidebar .edit-title {
  font-size: 14px;
  font-weight: 800;
  color: #0a495c;
  width: auto;
}

.xfield-layout-page .xfield-page-shell {
  position: relative;
  width: 100%;
  background: transparent;
}

.xfield-layout-page .xfield-page-form {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: auto;
  box-shadow: none;
  border-radius: 0;
  background: transparent;
  padding: 0;
}

.xfield-layout-page .xfield-panel-body {
  max-height: none;
  overflow: visible;
  padding: 0 !important;
}

.xfield-layout-page .page_title {
  position: static !important;
}

.xfield-layout-page .btn-save-exit {
  background-color: #12576e;
  border-color: #12576e;
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0.75rem 1rem;
  max-width: 220px;
  width: 100%;
}

.xfield-session-title {
  position: relative;
  color: #12576e;
}

.xfield-session-title-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  color: #12576e;
  font-weight: 600;
  position: relative;
  z-index: 1;
}

.xfield-session-title-icon {
  font-size: 1.15rem;
  line-height: 1;
  color: #12576e;
}

.xfield-session-title-img-wrap {
  display: inline-flex;
  width: 1.35rem;
  height: 1.35rem;
  flex-shrink: 0;
}

.xfield-session-title-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.xfield-session-title-text {
  line-height: 1.3;
}

.xfield-layout-page .radio_session_icon {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  width: 100%;
  max-width: 300px;
  float: none !important;
  clear: both;
  margin-left: auto;
}

.xfield-layout-page .radio-class-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  min-width: 2.75rem;
  min-height: 2.75rem;
  padding: 0.25rem;
  text-align: center;
  border-radius: 0.45rem;
}

.xfield-layout-page .xfield-page-radio-icon,
.xfield-layout-page .xfield-page-radio-icon::before {
  display: block;
  font-size: 2rem !important;
  line-height: 1 !important;
  margin: 0 auto;
  text-align: center;
}

.xfield-layout-page .base-input,
.xfield-layout-page fieldset {
  margin-bottom: 0.85rem;
}

/* Desktop: span em 2 colunas — label | .has-label */
@media (min-width: 768px) {
  .xfield-layout-page span.xfield-radio-icon-row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem 1rem;
    width: 100%;
  }

  /*
   * b-form-group renderiza: fieldset.form-group > div > (label + .has-label)
   * display:contents "desembrulha" os wrappers para as duas colunas
   * ficarem filhas diretas do span no layout flex.
   */
  .xfield-layout-page span.xfield-radio-icon-row > .form-group,
  .xfield-layout-page span.xfield-radio-icon-row > fieldset,
  .xfield-layout-page span.xfield-radio-icon-row > .form-group > div,
  .xfield-layout-page span.xfield-radio-icon-row > fieldset > div {
    display: contents;
  }

  .xfield-layout-page span.xfield-radio-icon-row .form-control-label {
    float: none !important;
    display: block;
    flex: 1 1 0;
    min-width: 0;
    width: auto;
    max-width: none;
    margin-bottom: 0 !important;
    text-align: left;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.35;
  }

  .xfield-layout-page span.xfield-radio-icon-row .has-label {
    flex: 0 0 auto;
    width: auto !important;
    max-width: none;
    margin-left: auto;
  }

  .xfield-layout-page span.xfield-radio-icon-row .radio_session_icon {
    width: auto;
    max-width: none;
    margin-left: 0;
    margin-bottom: 0 !important;
    justify-content: flex-end;
  }
}

@media (max-width: 767.98px) {
  .xfield-layout-page .form-control-label {
    float: none !important;
    display: block;
    width: 100%;
    margin-bottom: 0.45rem;
  }

  .xfield-layout-page .radio_session_icon {
    float: none !important;
    justify-content: space-between;
    margin-left: 0;
    max-width: 100%;
    width: 100%;
    gap: 5px;
  }

  .xfield-layout-page .radio-class-box {
    flex: 1 1 0;
    min-width: 0;
    padding: 0.2rem;
  }

  .xfield-layout-page .xfield-page-radio-icon,
  .xfield-layout-page .xfield-page-radio-icon::before {
    font-size: 1.5rem !important;
  }

  .xfield-layout-page .btn-save-exit {
    max-width: none;
  }

  .xfield-session-title-label {
    max-width: 92%;
    flex-wrap: wrap;
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
